
import React from "react";
import { Button } from "@/components/ui/button";
import { PenLine, CheckCircle, XCircle } from "lucide-react";

interface ClientInfoActionsProps {
  isEditing: boolean;
  isSaving: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

export const ClientInfoActions: React.FC<ClientInfoActionsProps> = ({
  isEditing,
  isSaving,
  onEdit,
  onSave,
  onCancel
}) => {
  if (!isEditing) {
    return (
      <Button 
        variant="ghost" 
        size="icon" 
        className="text-white/70 hover:text-white hover:bg-white/10"
        onClick={onEdit}
      >
        <PenLine className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <div className="flex gap-2">
      <Button 
        variant="ghost" 
        size="icon" 
        className="text-green-500 hover:text-green-400 hover:bg-white/10"
        onClick={onSave}
        disabled={isSaving}
      >
        <CheckCircle className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        className="text-red-500 hover:text-red-400 hover:bg-white/10"
        onClick={onCancel}
        disabled={isSaving}
      >
        <XCircle className="h-4 w-4" />
      </Button>
    </div>
  );
};
